<!-- eslint-disable vue/no-mutating-props -->
<template>
    <v-data-table
        :headers="tableHeaders"
        :items="defectsItems"
        item-key="plateId"
        hide-default-footer
        disable-pagination
        dense
        class="elevation-1"
    >
        <template #item.orderNumber="{item}">
            <div v-if="item.orderNumber">
                <v-chip x-small label class="ma-0">
                    {{ item.orderNumber }}
                </v-chip>
            </div>
        </template>
        <template #item.defectiveAmountPercent="{item}">
            <span v-if="item.defectiveAmountPercent !== null && item.defectiveAmountPercent !== undefined">
                {{ formatPercent(item.defectiveAmountPercent) }}%
            </span>
        </template>
    </v-data-table>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
export default {
    name: 'DefectsTable',

    props: {
        complaint: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            tableHeaders: [
                {
                    text: 'Numer zlecenia',
                    value: 'jobNumber',
                    sortable: false
                },
                {
                    text: 'Numer montażu',
                    value: 'plateNumber',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Numer zamówienia',
                    value: 'orderNumber',
                    sortable: false
                },
                {
                    text: 'Komponenty',
                    value: 'component',
                    sortable: false
                },
                {
                    text: 'Nakład',
                    value: 'amount',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Wadliwy nakład',
                    value: 'defectiveAmount',
                    align: 'center',
                    sortable: false
                },
                {
                    text: 'Wadliwy nakład w %',
                    value: 'defectiveAmountPercent',
                    align: 'center',
                    sortable: false
                }
            ]
        }
    },

    computed: {
        defectsItems() {
            return this.complaint?.defects || []
        }
    },

    methods: {
        formatPercent(value) {
            if (value === null || value === undefined || value === '') return ''

            const num = Number(value)

            if (Number.isNaN(num)) return ''

            return num.toFixed(1)
        }
    }
}
</script>
